/**
 * useBriefing — the Heute-Briefing Entscheid counts (Story UI-U10).
 *
 * live mode → GET /agent/briefing via the tolerant fetchBriefing (feature-detected;
 *             ANY failure / absent / unrecognised → null → tiles without counts).
 * mock mode → deriveMockBriefing() (static counts so the Briefing shows tiles-with-
 *             counts in dev + tests).
 *
 * [Source: apps/web/src/features/communication-v2/hooks/useCommAssist.ts] (live/mock pattern)
 * [Source: apps/web/src/lib/data-mode.ts]
 * [Source: docs/stories/ui-u10-brok-briefing-ray.md AC4]
 */

import { useQuery } from '@tanstack/react-query';
import type { PendingWorkSummary } from '@brokly/shared';
import { qk } from '../../../lib/query-keys';
import { isLiveData } from '../../../lib/data-mode';
import { fetchBriefing, deriveMockBriefing } from '../api/briefing-api';

/** The briefing summary, or null when there is nothing usable to show (live only). */
export function useBriefing(): PendingWorkSummary | null {
  const live = isLiveData();
  // useQuery is ALWAYS called (hooks rule); disabled in mock mode.
  const { data } = useQuery<PendingWorkSummary | null>({
    queryKey: qk.agentBriefing(),
    queryFn: fetchBriefing,
    enabled: live,
    retry: false,
    staleTime: 60_000,
  });

  if (!live) return deriveMockBriefing();
  return data ?? null;
}
